import { LeafletContext } from 'page/map-context.js';
import { useContext, useEffect, useRef } from 'react';
import { IZoomControlProps, MapControlUI } from './map-control-ui.js';

export const MapControls = (props: IZoomControlProps) => {
  const mapFactory = useContext(LeafletContext);
  const MapFactoryRef = useRef(mapFactory);

  useEffect(() => {
    MapFactoryRef.current = mapFactory;
  }, [mapFactory]);

  const zoomInFn = () => {
    MapFactoryRef.current?.getMap()?.zoomIn();
  };

  const zoomOutFn = () => {
    MapFactoryRef.current?.getMap()?.zoomOut();
  };

  const resetFn = () => {
    MapFactoryRef.current?.resetMap();
  };

  return (
    <MapControlUI
      zoomIn={zoomInFn}
      zoomOut={zoomOutFn}
      reset={resetFn}
      {...props}
    />
  );
};
